import angular from 'angular';
import uiRouter from 'angular-ui-router';
import ngMessages from 'angular-messages';
import resetPasswordComponent from './reset-password.component';

let resetPasswordModule = angular.module('reset-password', [
    uiRouter,
    ngMessages
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
    $stateProvider
    .state('reset-password', {
        url: '/reset-password/:token',
        component: 'resetPassword',
        data: {
            permissions: {
                except: ['OPERATOR'],
                redirectTo: 'home'
            }
        }
    });
})
.component('resetPassword', resetPasswordComponent)
.name;

export default resetPasswordModule;
